import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-separator-element',
  templateUrl: './separator-element.component.html',
  styleUrls: ['./separator-element.component.scss']
})
export class SeparatorElementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
